import { parseISO } from 'date-fns'

/**
 * Date文字列またはDateオブジェクトを安全にparseISOするためのヘルパー関数
 * @param dateValue パースする可能性のあるDate文字列またはDateオブジェクト (null, undefined, 空文字を含む)
 * @returns パースされたDateオブジェクト、または無効な場合はnull
 */
export const safeParseISO = (
  dateValue: string | Date | null | undefined
): Date | null => {
  // Dateオブジェクトの場合はそのまま返す
  if (dateValue instanceof Date) {
    return isNaN(dateValue.getTime()) ? null : dateValue
  }

  // 文字列の場合はparseISOを使用
  if (typeof dateValue === 'string' && dateValue.length > 0) {
    try {
      const parsedDate = parseISO(dateValue)
      // パースされた日付が有効かチェック
      if (!isNaN(parsedDate.getTime())) {
        return parsedDate
      } else {
        return null
      }
    } catch (e) {
      return null
    }
  }
  return null
}
